export default __webpack_public_path__ + "static/media/NoSharkTarget.13729b27.zpt";